import styled from '@emotion/styled/macro';
import { BaseButton, Spinner, Variables } from '@enter/core';

export const ButtonBar = styled.div`
    margin-top: 56px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
`;

export const CancelButton = styled(BaseButton)`
    border-color: ${Variables.Colors.n70};
    white-space: nowrap;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n70};
    border: none;

    &:focus {
        border: 1px solid ${Variables.Colors.b300};
        box-shadow: inset 0 0 0 2px ${Variables.Colors.b300_l90};
    }
`;
export const SaveButton = styled(BaseButton)`
    border-color: ${Variables.Colors.n70};
    white-space: nowrap;

    &:focus {
        box-shadow: inset 0 0 0 2px ${Variables.Colors.b75};
    }
`;
export const StopButton = styled(CancelButton)``;

export const Pending = styled(Spinner)`
    background-color: transparent;
`;
